import { createSelector } from '@reduxjs/toolkit';
import { IInitialState } from 'types';

const inventory = (r: IInitialState) => r.inventory;
export const inventoryListSelector = createSelector(
  inventory,
  r => r.inventoryList
);
